import { useEffect, useRef } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import EmptyLayout from "./layouts/EmptyLayout";
import ExpoPage from "./pages/\bexpoPage";
import MainPage from "./pages/MainPage";
import NotFoundPage from "./pages/NotFoundPage.tsx";
import MaterplanPage from "./pages/dev/MaterplanPage";
import SpaceModePage from "./pages/dev/SpaceModePage";
import StudiosPage from "./pages/dev/StudiosPage";
import TimelineModePage from "./pages/dev/TimelineModePage";

import PanoramaPage from "./components/kproject/PanoramaPage";
import C4Page from "./pages/C4Page";
import C4Page1 from "./pages/C4Page1";
import Untitled from "./pages/untitled";

export default function App() {
  const location = useLocation();
  const prevLocation = useRef(location.pathname);

  useEffect(() => {
    // 이전 URL과 현재 URL을 비교
    if (prevLocation.current !== location.pathname) {
      window.location.reload();
      prevLocation.current = location.pathname; // 현재 URL을 이전 URL로 업데이트
    }
  }, [location]);

  return (
    <div style={{ height: "100vh", overflow: "hidden" }}>
      <Routes>
        {/* 프러덕션 라우트 */}
        <Route element={<EmptyLayout />} path="/">
          <Route index element={<Navigate replace to="/expo" />} />
          <Route index element={<MainPage />} path="Kproject" />
          <Route index element={<ExpoPage />} path="expo" />
          <Route index element={<C4Page />} path="C4" />
          <Route index element={<C4Page1 />} path="C4-1" />
          <Route element={<PanoramaPage />} path="panorama" />
          <Route element={<Untitled />} path="seongsu" />
        </Route>
        {/* 개발용 라우트 */}
        <Route element={<EmptyLayout />} path="/dev">
          <Route element={<StudiosPage />} path="studios" />
          <Route element={<MaterplanPage />} path="masterplan" />
          <Route element={<SpaceModePage />} path="space-mode" />
          <Route index element={<C4Page />} path="C4" />
          <Route element={<TimelineModePage />} path="timeline-mode" />
        </Route>
        {/* Notfound page */}
        <Route element={<EmptyLayout />} path="/">
          <Route element={<NotFoundPage />} path="*" />
        </Route>
      </Routes>
    </div>
  );
}
